<template>
  <div class="page-content user-plan">
    <div class="row">
      <div class="col-12">
        <user-plan-history />
      </div>
      <div class="col-6">
        <send-monthly-membership-receipt />
      </div>
      <div class="col-6">
        <send-subscription-history />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const UserPlanHistory = defineAsyncComponent(() => import('./UserPlan/UserPlanHistory.vue') as any);

const SendMonthlyMembershipReceipt = defineAsyncComponent(() => import('./UserPlan/SendMonthlyMembershipReceipt.vue') as any);

const SendSubscriptionHistory = defineAsyncComponent(() => import('./UserPlan/SendSubscriptionHistory.vue') as any);

const route = useRoute();

onMounted(async () => {
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
